import { debounce, put, select } from 'redux-saga/effects';

import { DEBOUNCE_TIME } from 'constants/Global';
import { PATH } from 'constants/RoutesConstants';
import { scopeToPage } from 'modules/app/sagas/utils';
import { getSelectedContactListId } from 'modules/contactLists/selectors/details';
import * as types from 'modules/contactMembers/actionTypes';
import { getContactMembersParams } from 'modules/contactMembers/selectors';

import { fetchContactMembers } from '../actions/core';

function* refreshContactMembers() {
  const params = yield select(getContactMembersParams);
  const contactListId = yield select(getSelectedContactListId);
  yield put(fetchContactMembers(contactListId, { ...params, page: 0 }));
}

function* onDetailsWorker() {
  yield debounce(
    DEBOUNCE_TIME,
    [
      types.SET_CONTACT_MEMBERS_FILTER,
      types.SET_CONTACT_MEMBERS_FILTERS,
      types.CLEAR_CONTACT_MEMBERS_FILTER,
      types.REMOVE_CONTACT_MEMBERS_FILTER,
    ],
    refreshContactMembers
  );
}

export default function* contactMembersSaga() {
  yield scopeToPage([PATH.CONTACT_LISTS_DETAILS], onDetailsWorker);
}
